import { render, staticRenderFns } from "./ns-procurement-quantity.vue?vue&type=template&id=ef83e49c&"
import script from "./ns-procurement-quantity.vue?vue&type=script&lang=js&"
export * from "./ns-procurement-quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports